export default "__VITE_ASSET__06704a07__"